<script lang="ts" setup>
</script>

<template>
  <svg
    class="w-6 h-6"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 2v4" stroke-linecap="round" stroke-linejoin="round" />
    <circle
      cx="12"
      cy="2"
      r="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />

    <rect
      height="15"
      rx="4"
      stroke-linecap="round"
      stroke-linejoin="round"
      width="18"
      x="3"
      y="6"
    />

    <circle
      cx="8.5"
      cy="12"
      r="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle
      cx="15.5"
      cy="12"
      r="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />

    <path d="M8 17h8" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>

<style scoped></style>
